import Resource from './resource';
import ElementAttribute from './element';
import { Resources, Attributes, Elements, Category, Weaponskills } from '../character/allValues';
import DiceAttribute from './diceAttribute';
import ValueAttribute from './valueAttribute';
import WeaponAttribute from './weapon';

export default class BaseAttributeCollection {
  public baseResources: Resource[] = [
    new Resource(Resources.lep),
    new Resource(Resources.aip),
    new Resource(Resources.ini),
    new Resource(Resources.np),
    new Resource(Resources.spi),
  ];

  public baseCombatResources: Resource[] = [
    new Resource(Resources.wnd),
    new Resource(Resources.zwf),
    new Resource(Resources.ersch),
    new Resource(Resources.ar),
  ];

  public baseExperience: Resource[] = [new Resource(Resources.ep), new Resource(Resources.hp)];

  public baseDiceResources: DiceAttribute[] = [new DiceAttribute(Resources.wid), new DiceAttribute(Resources.wil)];

  public baseAttributes: ValueAttribute[] = [new ValueAttribute(Attributes.ws), new ValueAttribute(Attributes.gs)];

  public baseDiceAttributes: DiceAttribute[] = [
    new DiceAttribute(Attributes.sta),
    new DiceAttribute(Attributes.kon),
    new DiceAttribute(Attributes.wen),
    new DiceAttribute(Attributes.ges),
    new DiceAttribute(Attributes.tap),
    new DiceAttribute(Attributes.sel),
    new DiceAttribute(Attributes.int),
    new DiceAttribute(Attributes.sch),
    new DiceAttribute(Attributes.wei),
    new DiceAttribute(Attributes.bil),
    new DiceAttribute(Attributes.cha),
    new DiceAttribute(Attributes.auf),
  ];

  public baseCombatDiceAttributes: DiceAttribute[] = [
    // Attack
    new WeaponAttribute(Weaponskills.axte),
    new WeaponAttribute(Weaponskills.fechtwaffen),
    new WeaponAttribute(Weaponskills.feuerwaffen),
    new WeaponAttribute(Weaponskills.hammer),
    new WeaponAttribute(Weaponskills.kettenwaffen),
    new WeaponAttribute(Weaponskills.messerdolche),
    new WeaponAttribute(Weaponskills.poles),
    new WeaponAttribute(Weaponskills.schusswaffen),
    new WeaponAttribute(Weaponskills.shield),
    new WeaponAttribute(Weaponskills.sword),
    new WeaponAttribute(Weaponskills.strat),
    new WeaponAttribute(Weaponskills.unarmed),
    new WeaponAttribute(Weaponskills.wurfwaffen),
    // Defense
    new WeaponAttribute(Weaponskills.axte, true),
    new WeaponAttribute(Weaponskills.fechtwaffen, true),
    new WeaponAttribute(Weaponskills.feuerwaffen, true),
    new WeaponAttribute(Weaponskills.hammer, true),
    new WeaponAttribute(Weaponskills.kettenwaffen, true),
    new WeaponAttribute(Weaponskills.messerdolche, true),
    new WeaponAttribute(Weaponskills.poles, true),
    new WeaponAttribute(Weaponskills.schusswaffen, true),
    new WeaponAttribute(Weaponskills.shield, true),
    new WeaponAttribute(Weaponskills.sword, true),
    new WeaponAttribute(Weaponskills.strat, true),
    new WeaponAttribute(Weaponskills.unarmed, true),
    new WeaponAttribute(Weaponskills.wurfwaffen, true),
    new WeaponAttribute(Weaponskills.evasion, true),
  ];

  public baseElements: ElementAttribute[] = [
    new ElementAttribute(Elements.feuer, false),
    new ElementAttribute(Elements.wasser, false),
    new ElementAttribute(Elements.erde, false),
    new ElementAttribute(Elements.wind, false),
    new ElementAttribute(Elements.licht, false),
    new ElementAttribute(Elements.schatten, false),
    new ElementAttribute(Elements.blut, false),
    new ElementAttribute(Elements.nebel, false),

    // Schutzwerte
    new ElementAttribute(Elements.feuer, true),
    new ElementAttribute(Elements.wasser, true),
    new ElementAttribute(Elements.erde, true),
    new ElementAttribute(Elements.wind, true),
    new ElementAttribute(Elements.licht, true),
    new ElementAttribute(Elements.schatten, true),
    new ElementAttribute(Elements.blut, true),
    new ElementAttribute(Elements.nebel, true),
  ];

  get allValues() {
    return [
      ...this.baseResources,
      ...this.baseCombatResources,
      ...this.baseExperience,
      ...this.baseDiceResources,
      ...this.baseAttributes,
      ...this.baseDiceAttributes,
      ...this.baseElements,
      ...this.baseCombatDiceAttributes,
    ];
  }

  public getCategoryByAbbreviation(abbreviation: string) {
    if (this.baseResources.findIndex((resource) => resource.abbreviation === abbreviation) > -1) {
      return Category.Resource;
    }
    if (this.baseCombatResources.findIndex((resource) => resource.abbreviation === abbreviation) > -1) {
      return Category.Resource;
    }
    if (this.baseElements.findIndex((resource) => resource.abbreviation === abbreviation) > -1) {
      return Category.Element;
    }
    if (this.baseDiceResources.findIndex((resource) => resource.abbreviation === abbreviation) > -1) {
      return Category.Resource;
    }
    if (this.baseDiceAttributes.findIndex((resource) => resource.abbreviation === abbreviation) > -1) {
      return Category.Attribute;
    }
    if (this.baseAttributes.findIndex((resource) => resource.abbreviation === abbreviation) > -1) {
      return Category.Attribute;
    }
    if (this.baseExperience.findIndex((resource) => resource.abbreviation === abbreviation) > -1) {
      return Category.Resource;
    }
    if (this.baseCombatDiceAttributes.findIndex((resource) => resource.abbreviation === abbreviation) > -1) {
      return Category.Weapon;
    }
    const found = this.allValues.find((value) => value.abbreviation === abbreviation);
    if (typeof found !== 'undefined') {
      return found.category;
    } else {
      return null;
    }
  }
}
